module.exports = "/static/assets/1a375f587f65a466438a7e60100a8750.png";